const maxAllowedDateDifference = 1;

export default maxAllowedDateDifference;
